import React from "react";
import { NumberInput, Stack } from "@mantine/core";
import {
  AR_FORM_NUMBER_INPUT_PROPS,
  getArFormValues,
  setArFormNestedField,
  transactionTypesIncludeRedemption,
} from "../helpers/arFormUtils";

const partGFieldStyles = {
  label: {
    lineHeight: 1.35,
    display: "block",
    whiteSpace: "normal",
  },
};

const OrderArFormPartG = ({ form }) => {
  const arForm = getArFormValues(form);
  if (!transactionTypesIncludeRedemption(arForm.transactionType)) return null;

  const internalUse = arForm.internalUse ?? {};

  return (
    <Stack spacing="md">
      <NumberInput
        styles={partGFieldStyles}
        label="Total Current Value (HKD) 總現值"
        value={internalUse.totalCurrentValue ?? ""}
        onChange={(value) =>
          setArFormNestedField(form, "internalUse.totalCurrentValue", value)
        }
        precision={2}
        min={0}
        hideControls
        {...AR_FORM_NUMBER_INPUT_PROPS}
      />
      <NumberInput
        styles={partGFieldStyles}
        label="Total Profit / Loss (HKD) 總盈虧"
        value={internalUse.totalProfitLoss ?? ""}
        onChange={(value) =>
          setArFormNestedField(form, "internalUse.totalProfitLoss", value)
        }
        precision={2}
        hideControls
        {...AR_FORM_NUMBER_INPUT_PROPS}
      />
      <NumberInput
        styles={partGFieldStyles}
        label="Net Contribution (HKD) 淨供款"
        value={internalUse.netContribution ?? ""}
        onChange={(value) =>
          setArFormNestedField(form, "internalUse.netContribution", value)
        }
        precision={2}
        min={0}
        hideControls
        {...AR_FORM_NUMBER_INPUT_PROPS}
      />
    </Stack>
  );
};

export default OrderArFormPartG;
